import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/styles.css'; // Import global styles

// Import FontAwesome core and components
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Import specific icons
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons';

// Add icons to the library
library.add(faShoppingCart, faInstagram, faFacebook, faTwitter);

// Create the Vue app, register the FontAwesomeIcon component, and mount the app
createApp(App)
    .component('font-awesome-icon', FontAwesomeIcon) // Register the FontAwesomeIcon component globally
    .mount('#app');

createApp(App).use(router).mount('#app');
